<template lang="html">
  <component :is="headerContext.componentName" v-bind="headerContext.props" />
</template>

<script>
import { mapState } from 'vuex';

import HeaderNavDefault from '@/components/HeaderNavDefault';
import HeaderNavBack from '@/components/HeaderNavBack';

export default {
  name: 'HeaderNav',

  components: {
    HeaderNavDefault,
    HeaderNavBack,
  },

  computed: {
    ...mapState(['headerContext']),
  },
};
</script>
